import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IUserStore } from '../../user/user.store';
import { OpacityControl } from '../components/OpacityControl';

export const OpacityContainer = observer((): ReactElement => {
  const userStore = useInjection(IUserStore.$);

  const handleOpacityLevelChange = (opacity: number): void => {
    userStore.opacityLevel = opacity;
  };

  return (
    <OpacityControl
      onOpacityLevelChange={handleOpacityLevelChange}
      opacityLevel={userStore.opacityLevel}
      minOpacityLevel={0}
      maxOpacityLevel={100}
    />
  );
});
